import * as api from '../apiHelper';
import {
  setSubmissionLoaderLoading,
  setSubmissionLoaderReset,
} from '../fetchLoaderActions';
import { arriveNotice } from '../noticeActions';

async function postResultsMonetizationRequestApi(token, body) {
  const response = await api.post({
    path: 'results/monetization-requests',
    token,
    body,
    version: 'gateway',
  });

  return response.json();
}

export function initiateResultsMonetizationRequest(body, onSuccess = () => null) {
  return async (dispatch, getState) => {
    const {
      auth: { token, paymentPending },
      fetchLoader: { submissionLoading },
    } = getState();

    if (paymentPending || submissionLoading) return;

    dispatch(setSubmissionLoaderLoading());

    try {
      const response = await postResultsMonetizationRequestApi(token, body);
      dispatch(arriveNotice('Monetization request submitted'));
      onSuccess(response);
    } catch (e) {
      if (e.name !== 'AbortError') {
        dispatch(arriveNotice(e.message));
      }
    } finally {
      dispatch(setSubmissionLoaderReset());
    }
  };
}

export default initiateResultsMonetizationRequest;
